import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

class ReviewsSlider extends React.Component {

  render() {
    let data = this.props.data

    let hasImage = (item) => (
      item.promote === "On" && (item.field_review_live_image !== '' || item.field_review_arts_image !== '')
    )

    let imageData = data.filter(hasImage)

    const slider = imageData.map((item, index) =>
        <div className="inside-slider" key={index}>
          <div className="banner-image" style={{ backgroundImage: 'url("//jeff.4zzz.org.au/' +  ( item.field_review_live_image ? item.field_review_live_image : item.field_review_arts_image ) + '")' }}>
            <Link to={{pathname: 'reviews/' + item.path, state: { modal: true, data: item }}}>
              <div className="reviews-summary">
                <div>
                  <span>{ item.type.replace('Review - ', '') }</span>
                </div>
                <div>
                  <span>{ item.title }</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
    )

    var settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false
    };
    if (this.props.data.length > 0) {
      return (
        <Slider className="reviews-slider" {...settings}>
          {slider}
        </Slider>
      )
    }
    else {
      return ( null )
    }
  }
}

export default ReviewsSlider
